import { howDidYouHeardOptionBaseValues } from "./HowDidYouHearModal.consts";
import { HowDidYouHeardOptionKey } from "./HowDidYouHearModal.types";

/**
 * Narrows a saved `host_heard_from` string to a known checkbox key. The API
 * returns plain strings, so this is the only place that vouches for them.
 */
const isHowDidYouHeardOptionKey = (
  savedOption: string,
): savedOption is HowDidYouHeardOptionKey =>
  savedOption !== "otherDetail" &&
  savedOption in howDidYouHeardOptionBaseValues;


export { isHowDidYouHeardOptionKey }